import { render, staticRenderFns } from "./table-card.vue?vue&type=template&id=b20d0ada"
import script from "./table-card.vue?vue&type=script&lang=js"
export * from "./table-card.vue?vue&type=script&lang=js"
import style0 from "./table-card.vue?vue&type=style&index=0&id=b20d0ada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports